module.exports = __webpack_public_path__ + "static/img/zhuanli03.9b48833.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/intellectualProperty/zhuanli03.png
// module id = /R4y
// module chunks = 1